export const LATIN_CHARACTERS_ERROR = 'latin_characters_error'

/* The anamnesis ends up in a PDF whose font only covers the Latin script, and the practice staff
 * has to be able to read it. The backend drops every character the font can't render, which
 * silently loses information, so we only accept what survives that step:
 *
 * - tabs, line breaks and printable ASCII (U+0020–U+007E)
 * - Latin-1 Supplement (U+00A0–U+00FF): ä, ö, ü, ß, é, ñ, «», §, °, …
 * - Latin Extended-A (U+0100–U+017F): Polish, Czech, Turkish, Hungarian, Croatian, … letters
 * - the Romanian ș and ț from Latin Extended-B (U+0218–U+021B)
 * - the dashes and quotes that mobile keyboards insert automatically (U+2010–U+201E), the bullet
 *   (U+2022), the ellipsis (U+2026) and the euro sign (U+20AC)
 *
 * Everything else is rejected: Cyrillic, Greek, Arabic, CJK, emoji, …
 */
export const latinTextRegex = /^[\t\n\r\u0020-\u007E\u00A0-\u017F\u0218-\u021B\u2010-\u201E\u2022\u2026\u20AC]*$/

/* The value is normalized first, so an "é" typed as "e" plus a combining accent (common when
 * pasting on macOS) is treated like the precomposed "é".
 */
export const isLatinText = (value: string): boolean => latinTextRegex.test(value.normalize('NFC'))

export const areLatinTexts = (values: Array<string | null | undefined>): boolean =>
  values.every((value) => !value || isLatinText(value))
